<div class="nav" [ngClass]="{'sticky': sticky}">
    <div class="nav__title"></div>
    <div class="nav__actions">
        <ng-content></ng-content>
    </div>
</div>